import useGetLegacyNavigationUrl from 'hooks/meta/useGetLegacyNavigationUrl';
import { useCallback } from 'react';

export default function useLegacyLogoutNavigation() {
  const navigation = useGetLegacyNavigationUrl('logout');

  return useCallback(() => {
    window.location.assign(navigation());
  }, [navigation]);
}
